import { render, staticRenderFns } from "./QuotesList.vue?vue&type=template&id=14c08b50&scoped=true&"
import script from "./QuotesList.vue?vue&type=script&lang=js&"
export * from "./QuotesList.vue?vue&type=script&lang=js&"
import style0 from "./QuotesList.vue?vue&type=style&index=0&id=14c08b50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c08b50",
  null
  
)

export default component.exports